import type { RadioGroupOption } from '../../common/FormFields/RadioGroupInput/RadioGroupInput';

export type GreenPowerField =
  | 'swap'
  | 'wind'
  | 'water'
  | 'photovoltaic'
  | 'biomass'
  | 'consumption'
  | 'certification'
  | 'label'
  | 'regionOfOrigin'
  | 'numberOfMeterPoints'
  | 'controlArea'
  | 'customControlArea'
  | 'product';

export type GreyPowerField =
  | 'consumption'
  | 'numberOfMeterPoints'
  | 'controlArea'
  | 'customControlArea'
  | 'product';

export function getGreenGreyPowerProductOptions(): RadioGroupOption[] {
  return [
    { value: 'fahrplan', labelText: 'Fahrplan' },
    { value: 'standardprodukt', labelText: 'Standardprodukt' },
  ];
}
